module.exports = __webpack_public_path__ + "img/douyu_help.8f3406c2.jpg";